export default __webpack_public_path__ + "static/media/player_enter.ef82c1a9.mp3";